import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    padding: theme.spacings.lg,
  },
  title: {
    fontSize: theme.fontSizes['3xl'],
    marginBottom: theme.spacings.lg,
  },
  errorText: {
    fontSize: theme.fontSizes.xl,
    marginBottom: theme.spacings.lg,
    color: theme.colors.red,
    fontWeight: 'bold',
  },
  infoText: {
    fontSize: theme.fontSizes.xl,
    marginBottom: theme.spacings.lg,
  },
  centered: {
    alignItems: 'center',
  },
  otpRow: {
    flexDirection: 'row',
    columnGap: theme.spacings.md,
  },
  otpCell: {
    borderWidth: 2,
    height: 56,
    width: theme.spacings['2xl'],
    borderRadius: theme.borderRadii.xl,
    alignItems: 'center',
    justifyContent: 'center',
  },
  otpCellText: {
    textAlign: 'center',
    fontSize: theme.fontSizes['2xl'],
    fontWeight: 'bold',
  },
  loadingIndicator: {
    position: 'absolute',
    right: -48,
    top: theme.spacings.md,
  },
  resendCodeActive: {
    fontSize: theme.fontSizes.lg,
    marginTop: theme.spacings.md,
    fontWeight: 'bold',
    color: theme.colors.primary,
  },
  resendCodeSent: {
    fontSize: theme.fontSizes.lg,
    marginTop: theme.spacings.md,
    fontWeight: 'bold',
    color: theme.colors.darkPurpleBlue,
  },
  codeSentConfirmation: {
    marginTop: theme.spacings.sm,
    fontSize: theme.fontSizes.lg,
    color: theme.colors.darkPurpleBlue,
  },
  hiddenInput: {
    opacity: 0,
  },
});
